import { actionCreatorFactory } from 'typescript-fsa';
import { NotificationSettings } from './types';

const createAction = actionCreatorFactory('PROFILE');
const fetchNotifications = createAction.async<void, NotificationSettings, Error>('FETCH');
const needToVerify = createAction('VERIFY');

export { fetchNotifications, needToVerify };
